import React from "react";
import { View, StyleSheet, Dimensions } from "react-native";
import Slider from "@react-native-community/slider";
import Text from "@components/AppText";

const ProgressBar = ({
  currentTime = 0,
  duration = 0,
  onSlideCapture = () => {},
  handlePlayPause = () => {},
  fullScreen = false,
}) => {
  const getMinutesFromSeconds = (seconds) => {
    const minutes = seconds >= 60 ? Math.floor(seconds / 60) : "00";
    let secondsLeft = Math.floor(seconds % 60);
    secondsLeft =
      `${secondsLeft}`.length === 2 ? secondsLeft : `0${secondsLeft}`;

    return `${minutes < 10 ? `${minutes}` : minutes}:${
      secondsLeft < 10 ? `${secondsLeft}` : secondsLeft
    }`;
  };

  const position = getMinutesFromSeconds(currentTime);
  const fullDuration = getMinutesFromSeconds(duration);

  const handleSeekTime = (data) => {
    onSlideCapture({ seekTime: data });
  };

  return (
    <View
      style={[
        styles.wrapper,
        { bottom: -8, position: fullScreen ? "relative" : "absolute" },
      ]}
    >
      {fullScreen && (
        <View style={styles.timeWrapper}>
          <Text fontType="content1" style={styles.timeLeft}>
            {position}
          </Text>
          <Text style={{ color: "#fff", fontSize: 16 }}> / </Text>
          <Text fontType="content1" style={styles.timeRight}>
            {fullDuration}
          </Text>
        </View>
      )}
      <View
        style={{
          transform: [{ scaleX: 1.5 }, { scaleY: 1.5 }],
          width: fullScreen
            ? Dimensions.get("screen").width / 1.5
            : Dimensions.get("screen").width / 1.3,
          alignSelf: "center",
        }}
      >
        <Slider
          value={currentTime}
          minimumValue={0}
          maximumValue={duration}
          onValueChange={handleSeekTime}
          minimumTrackTintColor={"#F44336"}
          maximumTrackTintColor={"#FFFFFF"}
          thumbTintColor={"#F44336"}
          onSlidingComplete={() => {
            handlePlayPause(true);
          }}
          onSlideStart={() => {
            handlePlayPause(false);
          }}
        />
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  wrapper: {
    flex: 1,
    position: "absolute",
    width: "100%",
  },
  timeWrapper: {
    flexDirection: "row",
    // justifyContent: "space-between",
    alignItems: "center",
    padding: 5,
    width: "100%",
  },
  timeLeft: {
    color: "#fff",
    paddingLeft: 10,
    fontSize: 16,
  },
  timeRight: {
    color: "#fff",
    paddingRight: 10,
    fontSize: 16,
  },
});

export default ProgressBar;
